// =====================================================================
//      SECTIONS - GLOBAL
// =====================================================================

$('.is-light-section').parent().addClass('light-section')
$('.is-white-section').parent().addClass('white-section')
;(function ($, root, undefined) {
	$(function () {
		'use strict'

		// =====================================================================
		//      BROWSER DETECTION
		// =====================================================================

		var is_opera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0
		// var isEdge = document.documentMode || /Edge/.test(navigator.userAgent);

		if (document.documentMode || /Edge/.test(navigator.userAgent)) {
			$('body').addClass('browser_ie')
		}
		//Check if browser is Chrome
		else if (!!window.chrome && !is_opera) {
			$('body').addClass('browser_chrome')
		}
		//Check if browser is Firefox
		else if (typeof window.InstallTrigger !== 'undefined') {
			$('body').addClass('browser_firefox')
		}
		//Check if browser is Safari
		else if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
			$('body').addClass('browser_safari')
		}
		//Check if browser is Opera
		else if (is_opera) {
			$('body').addClass('browser_opera')
		}

		var isMobile = navigator.userAgent.match(/(iPhone|iPod|iPad)/i)
		if (isMobile) {
			$('body').addClass('ios')
		} else {
			$('body').addClass('notios')
		}

		// =====================================================================
		//      HEADER
		// =====================================================================

		/*-- MINIFIED --*/
		if (isMobile) {
			$(window).on('load scroll', function () {
				if (
					$(window).scrollTop() >=
					$('.header__heading-container').position().top +
						$('.header__heading-container').outerHeight() +
						30
				) {
					$('body').addClass('menu_fixed')
					$('.header').addClass('fixed').css('padding-bottom', $('.header__content').outerHeight())
				} else {
					$('body').removeClass('menu_fixed')
					$('.header').removeClass('fixed').css('padding-bottom', '')
				}
			})
		} else {
			$(window).on('load scroll', function () {
				if (
					$(window).scrollTop() >=
					$('.header__heading-container').position().top +
						$('.header__heading-container').outerHeight()
				) {
					$('body').addClass('menu_fixed')
					$('.header').addClass('fixed').css('padding-bottom', $('.header__content').outerHeight())
				} else {
					$('body').removeClass('menu_fixed')
					$('.header').removeClass('fixed').css('padding-bottom', '')
				}
			})
		}

		// =====================================================================
		//      SECTIONS - VIDEO
		// =====================================================================
		if ($('.video-section__placeholder').length) {
			$('.video-section__placeholder').on('click', function () {
				$(this).fadeOut()
				$(this).siblings('.video-section__video')[0].play()
			})
		}

		// =====================================================================
		//      PRODUCT CARD SLIDER
		// =====================================================================
		function init_thumbs_slider() {
			if ($('.card--product').length) {
				setTimeout(function () {
					if ($('.has_thumbs_slider .thumb_slider:not(.slick-initialized)').length) {
						$('.has_thumbs_slider .thumb_slider:not(.slick-initialized)').slick({
							slidesToShow: 1,
							slidesToScroll: 1,
							arrows: false,
							dots: true,
							fade: true,
							cssEase: 'linear',
							autoplay: false,
							autoplaySpeed: 500,
							pauseOnDotsHover: true,
						})
					}
				}, 200)
			}
		}

		// var origOpen = XMLHttpRequest.prototype.open;
		// XMLHttpRequest.prototype.open = function() {
		//     // console.log('request started!');
		//     this.addEventListener('load', function() {
		//         console.log('request completed!');
		//         // console.log(this.readyState); //will always be 4 (ajax is completed successfully)
		//         // console.log(this.responseText); //whatever the response was
		//         init_thumbs_slider();
		//     });
		//     origOpen.apply(this, arguments);
		// };
		//
		// $("body").on("domChanged", function() {
		//     console.log('dom changed');
		//     init_thumbs_slider();
		// });
		// // let open = XMLHttpRequest.prototype.open;
		//
		// $(document).ajaxComplete(function() {
		//     console.log('ajaxComplete');
		//     init_thumbs_slider();
		//
		// });

		MutationObserver = window.MutationObserver || window.WebKitMutationObserver
		var observer = new MutationObserver(function (mutations, observer) {
			init_thumbs_slider()
		})

		observer.observe(document, {
			subtree: true,
			attributes: true,
		})

		// if($('.has_thumbs_slider').length){
		//     $('.has_thumbs_slider .thumb_slider').slick({
		//       slidesToShow: 1,
		//       slidesToScroll: 1,
		//       arrows: false,
		//       dots: true,
		//       fade: true,
		//       cssEase: 'linear',
		//       autoplay: false,
		//       autoplaySpeed: 500,
		//       pauseOnDotsHover: true,
		//     });

		// $('.thumb_slider').mouseover(function() {
		//     $(this).slick('play')
		// });
		// $('.thumb_slider').mouseout(function() {
		//     $(this).slick('pause')
		// });
		// }
		// if($('.wishlist-hero-header-icon'))
		// $('.wishlist-hero-header-icon')

		// =====================================================================
		//      SINGLE PRODUCT TABS
		// =====================================================================
		if ($('.tabs_container').length) {
			$('.tab_nav_el').on('click', function (e) {
				if (!$(this).hasClass('current')) {
					$('.tab_nav_el').removeClass('current')
					$(this).addClass('current')
					$('.tab_el').removeClass('current')
					$('.tab_el[data-target="' + $(this).attr('data-target') + '"]').addClass('current')
				}
			})

			var nav_w = $('.tabs_nav ul').width()
			var cont_w = $('.tabs_container').width()
			var svg =
				'<svg xmlns="http://www.w3.org/2000/svg" width="8.509" height="15.603" viewBox="0 0 8.509 15.603"> <path id="Path_3783" data-name="Path 3783" d="M336.552,462,344,469.448l-7.448,7.448" transform="translate(-336.198 -461.646)" fill="none" stroke="#434343" stroke-width="1"/></svg>'
			var target

			$(window).on('load resize', function (e) {
				// nav_w = $('.tabs_nav ul').width();
				cont_w = $('.tabs_container').width()

				if (nav_w > cont_w) {
					$('.tabs_container').addClass('reduced')
					$('.tabs_nav ul:not(.slick-initialized)').slick({
						slidesToShow: 2,
						slidesToScroll: 1,
						arrows: true,
						dots: false,
						infinite: true,
						appendArrows: $('.tabs_nav_arrow'),
						nextArrow: '<button type="button" class="slick-prev">' + svg + '</button>',
						prevArrow: '',
					})
					$('.tabs_nav ul').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
						target = $('.tab_nav_el[data-slick-index="' + nextSlide + '"]').attr('data-target')
						$('.tab_nav_el').removeClass('current')
						$('.tab_nav_el[data-target="' + target + '"]').addClass('current')
						$('.tab_el').removeClass('current')
						$('.tab_el[data-target="' + target + '"]').addClass('current')
					})
				} else {
					$('.tabs_container').removeClass('reduced')
					$('.tabs_nav ul.slick-initialized').slick('unslick')
				}
			})
		}

		// console.log($('.wishlisthero-product-page-button-container').length);
		// if($('.wishlisthero-product-page-button-container').length){
		//     var wh_cont = $('.wishlisthero-product-page-button-container').clone(true);
		//     $('.wishlisthero-product-page-button-container').remove();
		//     $('.custom_single_product_title_container').append(wh_cont);
		// }

		if ($('.featured-collection__slider').length) {
			$('.featured-collection__slider').each(function (e) {
				var $slider = $(this)
				var $progressBar = $slider.siblings('.progress')
				var $progressBarLabel = $progressBar.find('.slider__label')

				$slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
					var calc = (nextSlide / (slick.slideCount - 1)) * 100

					$progressBarLabel.css('width', calc + '%')
				})

				$slider.slick({
					slidesToShow: 4,
					slidesToScroll: 1,
					arrows: true,
					dots: false,
					prevArrow:
						'<div class="slick-arrow slick-prev"><i class="fal fa-chevron-left"></i></div>',
					nextArrow:
						'<div class="slick-arrow slick-next"><i class="fal fa-chevron-right"></i></div>',
					responsive: [
						{
							breakpoint: 860,
							settings: {
								slidesToShow: 3,
							},
						},
						{
							breakpoint: 680,
							settings: {
								slidesToShow: 2,
							},
						},
					],
				})
			})
		}

		$('.close_facets').on('click', function (e) {
			$('.facets__disclosure').removeAttr('open')
		})

		//
		// $('.featured-collection__slider').on('init', function(event, slick){
		//     console.log($(this).find('.slick-list').width());
		//     console.log($(this).find('.slick-track').width());
		// });

		// =====================================================================
		//      CARROUSEL
		// =====================================================================

		if (window.innerWidth > 1024) {
			var $easyzoom = $('.easyzoom').easyZoom()
		} else {
			$('.easyzoom')
				.find('a')
				.click(function (e) {
					e.preventDefault()
					e.stopPropagation()
				})
		}

		const productsCarrousel = (carrousel) => {
			const mainSlider = carrousel.querySelector('.productsCarrousel__main__slider')
			const counterSlider = carrousel.querySelector('.productsCarrousel__counter')

			const navSlider = carrousel.querySelector('.productsCarrousel__navigation__slider')
			const arrowSvg = `
                            <svg xmlns="http://www.w3.org/2000/svg" width="8.509" height="15.603" viewBox="0 0 8.509 15.603">
                              <path id="Path_3783" data-name="Path 3783" d="M336.552,462,344,469.448l-7.448,7.448" transform="translate(-336.198 -461.646)" fill="none" stroke="#434343" stroke-width="1"/>
                            </svg>
                            `
			if (mainSlider && navSlider) {
				const mainSlidesArray = mainSlider.querySelectorAll('.productsCarrousel__item')
				const slidesToShow = Math.min(mainSlidesArray.length, 5)

				mainSlidesArray.forEach((slide, index) => {
					const image = slide.querySelector('img')
					const src = image.getAttribute('src')
					const uid = `product-slider-image-${index}`
					if (window.innerWidth > 1024) {
						$(image).easyZoom()
					}
				})

				const init = () => {
					$(mainSlider).slick({
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows: false,
						dots: false,
						fade: true,
						asNavFor: '.slider_nav',
						adaptiveHeight: true,
						// mobileFirst: true,
						nextArrow: `<button type="button" class="slick-prev">${arrowSvg}</button>`,
						prevArrow: `<button type="button" class="slick-next">${arrowSvg}</button>`,
						responsive: [
							{
								breakpoint: 1024,
								settings: {
									dots: false,
									arrows: true,
								},
							},
							// {
							//     breakpoint: 768,
							//     settings: {
							//         dots: true,
							//         arrows: true
							//     }
							// },
							// {
							//     breakpoint: 480,
							//     settings: {
							//         dots: true,
							//         arrows: true
							//     }
							// },
						],
					})
					$(mainSlider).on('afterChange', function (event, slick, currentSlide) {
						counterSlider.innerHTML = `${currentSlide + 1} / ${mainSlidesArray.length}`
					})
					var arrows = false
					if (mainSlidesArray.length > 5) {
						arrows = true
					}
					$(navSlider).slick({
						slidesToShow: 6,
						slidesToScroll: 1,
						infinite: true,
						asNavFor: '.slider_for',
						refresh: true,
						dots: false,
						arrows: arrows,
						centerMode: false,
						focusOnSelect: true,
						nextArrow: `<button type="button" class="slick-prev">${arrowSvg}</button>`,
						prevArrow: `<button type="button" class="slick-next">${arrowSvg}</button>`,
					})

					navSlider.style.opacity = 1
					mainSlider.style.opacity = 1
				}

				init()
			}
		}

		const carrousel = document.querySelector('.productsCarrousel')
		if (carrousel) productsCarrousel(carrousel)
	})
})(jQuery, this)
